<template>
  <div>
    <van-popup
      v-model="isShow"
      round
      position="bottom"
      :close-on-popstate="true"
    >
      <div class="queryFlights">
        <van-tabs
          v-model="roundtrip"
          :border="false"
          line-width="30"
          line-height="3"
        >
          <van-tab
            name="1"
            :title="$t('qijiangdi','按起降地')"
            @click.native="changeTab(1)"
          />
          <van-tab
            name="0"
            title="按航班号"
            @click.native="changeTab(0)"
          />
        </van-tabs>

        <div
          class="van-hairline--bottom"
          v-show="roundtrip==0"
        >
          <van-field
            :placeholder="$t('MU9855','请输入航班号')"
            maxlength="10"
            v-model="flightNo"
            @blur="onInput"
          />
        </div>
        <!-- 按起降地 -->
        <van-row
          v-show="roundtrip==1"
          class=" city van-hairline--bottom"
          type="flex"
          align="center"
          :gutter="0"
        >
          <van-col
            span="10"
            class="depart-city"
            :class="[ clbz.depport.cityName ? '' : 'disable' ]"
            @click="changeCity(1)"
          >
            {{ clbz.depport.cityName || $t('C104','出发城市') }}
          </van-col>
          <van-col
            span="4"
            class="text-center"
            @click.native="exchangeCity"
          >
            <ld-icon
              class="full-width main-color"
              size="30"
              type="iconzhuanhuan"
            />
          </van-col>
          <van-col
            span="10"
            class="dest-city"
            :class="[ clbz.arrport.cityName ? '' : 'disable' ]"
            @click="changeCity(2)"
          >
            {{ clbz.arrport.cityName || $t('C105','到达城市') }}
          </van-col>
        </van-row>

        <van-row class="date">
          <van-col
            @click.native="showDate"
            class="depart-date"
            :class="[ departDate.date ? '' : 'disable' ]"
          >
            {{ departDate.monDay || $t('C106','出发日期') }}
            <span
              v-show="departDate.date"
              class="date-tip"
            >{{ departDate.week }}</span>
          </van-col>
        </van-row>

        <van-row
          type="flex"
          align="center"
        >
          <ldButton
            main
            size="lg"
            @click.native="search"
          >
            {{ $t('B002','查询') }}
          </ldButton>
        </van-row>
      </div>

      <!-- 城市 -->
      <city
        ref="city"
        :sys-type="way"
        @selected="arrdepChange"
        :show-tab="showTab"
        element=".carQuery"
      />
    </van-popup>
    <!--  -->
    <ld-calendar
      ref="date"
      @selected="getDate"
      element=".carQuery"
    />
  </div>
</template>

<script>
import { Popup, Row, Col, Field, CellGroup, Tab, Tabs } from 'vant'

import { formatDate } from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'
import City from 'Common/city'
// import { mapGetters } from 'vuex'
import { localget, localset } from 'Utils/storage'

export default {
  name: 'QueryCarFlight',
  components: {
    ldButton,
    City,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    ldCalendar: () => import('Common/ldCalendar'),
  },
  data() {
    return {
      roundtrip: 0, // 0 单程 1 往返 2需求单
      departDate: '', //出发时间
      arriveDate: '', //formatDate(new Date(),1),//回程时间
      way: 1, //1 出发城市  2到达城市
      isShow: false,
      flightNo: '',
      clbz: {
        minzj: '0',
        depport: {}, //出发城市信息
        arrport: {}, //到达城市信息
      },
      arrportReadonly:false,
      depportReadonly:false,
      historyLog:{},
    }
  },
  props:{
    depport:{
      type:Object,
      default:function(){ return {} }
    },
    arrport:{
      type:Object,
      default:function(){ return {} }
    },
    readonly:{
      type:Boolean,
      default:false
    },
    departTime:{
      type:String,
      default:''
    },
    showTab:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // ...mapGetters({
    // 	userInfo: 'userInfo',
    // }),
  },
  methods: {
    search() {
      let obj = {}
      if(!this.historyLog.car.queryStr){
        this.historyLog.car.queryStr={}
      }
      if (this.roundtrip == 1) {
        obj = {
          departAirport: this.clbz.depport.threeCode,
          arriveAirport: this.clbz.arrport.threeCode,
          departTime: this.departDate.date,
        }
        if (!obj.departAirport) {
          this.$toast(this.$t('F049', '请选择') + this.$t('C104', '出发城市'))
          return
        } else if (!obj.arriveAirport) {
          this.$toast(this.$t('F049', '请选择') + this.$t('C105', '到达城市'))
          return
        }
        Object.assign(this.historyLog.car.queryStr, {
          departDate: this.departDate,
          arriveDate: this.arriveDate,
          clbz: this.clbz,
        })
      } else if (this.roundtrip == 0) {
        obj = {
          departTime: this.departDate.date,
          flightNo: this.flightNo,
        }
        if (!obj.flightNo) {
          this.$toast(this.$t('MU9855', '请输入航班号'))
          return
        }
        Object.assign(this.historyLog.car.queryStr, {
          departDate: this.departDate,
          flightNo: this.flightNo,
        })
      }
      if (this.departDate.monDay == undefined) {
        this.$toast('请选择日期')
        return
      }
      localset('_historyLog', this.historyLog)
      this.$api['carQuery/queryFlightByHbh'](obj).then((res) => {
        let cache = res.data || {}
        let list = cache.list || []
        if (list.length > 0) {
          this.$emit('selected', list, this.departDate.date)
          this.toggle()
        } else {
          this.$toast('没有查询到航班数据')
        }
      })
    },
    //打开日期控件
    showDate() {
      this.$refs.date.toggle({
        defaultDate:this.departDate.date
      })
    },
    //获取日期
    getDate(date) {
      this.departDate = formatDate(date)
    },
    // 出发 到达 交换
    exchangeCity(){
      if(this.readonly) return
      [this.clbz.depport, this.clbz.arrport] = [this.clbz.arrport, this.clbz.depport]
    },
    //打开城市控件
    changeCity(num) {
      if(num==1&&this.departReadonly){
        return
      }else if(num==2&&this.arrportReadonly){
        return
      }
      this.way = num
      this.$refs.city.toggle()
    },
    //得到城市信息
    arrdepChange(info, num) {
      this.cityIsShow = false
      if (num == 1) {
        this.clbz.depport = info
      } else {
        this.clbz.arrport = info
      }
    },
    onInput(){
      if(this.flightNo){
        this.flightNo=this.flightNo.toUpperCase()
      }
    },
    init(){
      let historyLog = localget('_historyLog')||{}
      if (historyLog.car) {
        let queryStr=historyLog.car.queryStr||{}
        // 历史查询记录的时间已经过了当前时间，就把历史查询的时间记录清空，默认时间为明天
        if (queryStr.departDate){
          let nowdate=formatDate(new Date()).date
          if(nowdate> queryStr.departDate.date){
            historyLog.car.queryStr.departDate = formatDate(new Date(), 1)
          }
        }
        this.historyLog=historyLog
      }
      var arrport=Object.keys(this.arrport)
      var depport=Object.keys(this.depport)
      if(arrport.length||depport.length){
        this.clbz={depport:{},arrport:{}}
        if(this.departTime){
          this.departDate=formatDate(this.departTime)
        }else{
          this.departDate=formatDate(new Date(), 1)
        }
      }
      if(historyLog.car){
        Object.assign(this, historyLog.car.queryStr)
      }else{
        this.historyLog={car:{queryStr:{}}}
      }
      if(arrport.length){
        Object.assign(this.clbz.arrport,this.arrport)
        if(this.readonly){
          this.arrportReadonly=true
        }
      }
      if(depport.length){
        Object.assign(this.clbz.depport,this.depport)
        if(this.readonly){
          this.departReadonly=true
        }
      }
        
    },
    toggle() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.init()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.disable {
  color: @color-text-gray;
}
.queryFlights {
  font-size: @font-size-16;
  padding: 16px;
  background-color: @color-background-white;
  > div {
    height: 1.1rem;
  }
  div.disable {
    color: @color-text-gray;
  }

  .cxr {
    font-family: @font-bold-md;
  }

  .city {
    font-size: @font-size-16;
    font-family: @font-bold-lg;
    .dest-city {
      text-align: right;
      padding: 10px 15px;
    }
    .depart-city {
      padding: 10px 15px;
    }
  }

  .date {
    .dest-date {
      text-align: right;
      font-family: @font-bold-md;
    }
    .date-tip {
      font-size: @font-size-12;
    }
    .depart-date {
      padding: 10px 15px;
    }
    .datepicker__wrapper {
      width: 0;
      height: 0;
      overflow: hidden;
    }
  }
}
</style>
